import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import ConfigPeriodosPresupuestariosGrid from './ConfigPeriodosPresupuestariosGrid.jsx';
import ConfigPeriodosPresupuestariosAbm from './ConfigPeriodosPresupuestariosAbm.jsx';
import { FormattedMessage } from 'react-intl';


const ConfigPeriodosPresupuestarios = ({ match }) => {

  return (
    <div className="content-wrapper">
      <div className="content-header row">
        <div className="content-header-left col-md-6 col-12 mb-2">
          <h3 className="content-header-title">
            <FormattedMessage
              id="configPeriodosPresupuestarios.label_listado_periodos_presupuestarios"
              defaultMessage="Configuraciones de Períodos Presupuestarios"
            />
          </h3>
        </div>
      </div>
      <div className="content-body">
        <Switch>
          <Route exact path={`${match.url}`} component={ConfigPeriodosPresupuestariosGrid} />
          <Route exact path={`${match.url}/add`} component={(props) => <ConfigPeriodosPresupuestariosAbm {...props} action="ADD" />} />
          <Route exact path={`${match.url}/:id/edit`} component={(props) => <ConfigPeriodosPresupuestariosAbm {...props} action="EDIT" />} />
          <Route exact path={`${match.url}/:id`} component={(props) => <ConfigPeriodosPresupuestariosAbm {...props} action="VIEW" />} />
        </Switch>
      </div>
    </div>
  );
};

export default withRouter(ConfigPeriodosPresupuestarios);